/* Quick View / Quick Add — pure JS */
(function () {
  'use strict';

  var modal, overlay, currencySymbol;
  var product = null;
  var variants = [];
  var optionNames = [];   /* ['Color', 'Size', ...] */
  var colorIdx = -1;      /* index of the color-like option, or -1 */
  var sel = [];           /* selected value per option index */

  function $(id) { return document.getElementById(id); }
  function $$(sel, root) { return (root || document).querySelectorAll(sel); }

  function init() {
    modal   = $('qv-modal');
    overlay = $('qv-overlay');
    if (!modal || !overlay) {
      console.warn('[QV] Modal not in DOM. Add {%- render \'quick-view\' -%} to layout.');
      return;
    }
    currencySymbol = modal.getAttribute('data-currency-symbol') || '$';

    overlay.addEventListener('click', close);
    var closeBtn = modal.querySelector('.qv-close');
    if (closeBtn) closeBtn.addEventListener('click', close);

    var atc = $('qv-atc');
    if (atc) atc.addEventListener('click', addToCart);

    var rm = $('qv-read-more');
    if (rm) rm.addEventListener('click', toggleDesc);

    /* Gallery carousel arrows (mobile) */
    var prevBtn = modal.querySelector('.qv-arrow-prev');
    var nextBtn = modal.querySelector('.qv-arrow-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollGallery(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollGallery(1); });
    var stack = $('qv-gallery-stack');
    if (stack) stack.addEventListener('scroll', updateArrows);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    /* Delegated trigger */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-quickview');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-quickview');
      if (handle) open(handle);
    });

    console.log('[QV] Initialized.');
  }

  function open(handle) {
    console.log('[QV] Opening:', handle);
    showLoading();
    show();

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (p) {
        try { populate(p); }
        catch (err) { showError('Could not render product: ' + err.message); console.error(err); }
      })
      .catch(function (err) {
        showError('Could not load product. ' + err.message);
        console.error('[QV] Fetch failed:', err);
      });
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function show() {
    overlay.classList.add('open');
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function showLoading() {
    $('qv-fabric').textContent = '';
    $('qv-fabric').style.display = 'none';
    $('qv-title').textContent = 'Loading…';
    $('qv-subtitle').textContent = '';
    $('qv-price').textContent = '';
    $('qv-compare').style.display = 'none';
    $('qv-desc').innerHTML = '';
    $('qv-read-more').style.display = 'none';
    $('qv-options').innerHTML = '';
    $('qv-error').style.display = 'none';
    $('qv-gallery-stack').innerHTML = '';
    var atc = $('qv-atc');
    atc.disabled = true;
    atc.textContent = 'ADD TO CART';
  }

  function showError(msg) {
    var el = $('qv-error');
    el.textContent = msg;
    el.style.display = '';
    $('qv-title').textContent = 'Error';
  }

  function populate(p) {
    product  = p;
    variants = p.variants || [];

    /* Read option names. Shopify may return options as plain strings
       (["Color","Size"]) or as objects ({name, position, values}) — normalize
       to strings. A product with no real variants reports a single "Title"
       option whose only value is "Default Title" — treat as none. */
    optionNames = (p.options || []).map(function (o) {
      return (o && typeof o === 'object') ? String(o.name || '') : String(o || '');
    });
    var isDefaultOnly = p.has_only_default_variant
      || (optionNames.length === 1
          && String(optionNames[0]).toLowerCase() === 'title'
          && variants.length === 1
          && variants[0].options[0] === 'Default Title');
    if (isDefaultOnly) optionNames = [];

    /* Which option is color-like? (drives swatch rendering + image sync) */
    colorIdx = -1;
    optionNames.forEach(function (opt, i) {
      var name = String(opt || '').toLowerCase();
      if (colorIdx < 0 && (name === 'color' || name === 'colour')) colorIdx = i;
    });

    /* Initial selection from first available variant */
    var firstAvail = variants.find(function (v) { return v.available; }) || variants[0];
    sel = firstAvail ? firstAvail.options.slice() : [];

    /* Brand / fabric */
    var fabric = '';
    (p.tags || []).forEach(function (t) {
      if (typeof t === 'string' && t.indexOf('fabric:') === 0) {
        fabric = t.replace('fabric:', '').trim();
      }
    });
    var fabricEl = $('qv-fabric');
    fabricEl.textContent = fabric || p.vendor || p.product_type || '';
    fabricEl.style.display = fabricEl.textContent ? '' : 'none';

    $('qv-title').textContent = p.title || '';
    $('qv-full-link').href = '/products/' + p.handle;

    updateSubtitle();

    /* Description */
    var descEl = $('qv-desc');
    descEl.innerHTML = p.description || '';
    descEl.classList.remove('expanded');
    var rmBtn = $('qv-read-more');
    rmBtn.style.display = 'none';
    rmBtn.textContent = 'Read more';
    setTimeout(function () {
      if (descEl.scrollHeight > 100) rmBtn.style.display = 'block';
    }, 60);

    renderGallery(p);
    renderOptions();
    updatePrice();
  }

  function updateSubtitle() {
    $('qv-subtitle').textContent = colorIdx >= 0 ? (sel[colorIdx] || '') : '';
  }

  function renderGallery(p) {
    var imgs = (p.images || []).slice(0, 6);
    var stack = $('qv-gallery-stack');
    stack.innerHTML = '';
    if (imgs.length === 0) {
      var ph = document.createElement('div');
      ph.style.cssText = 'width:100%;aspect-ratio:3/4;background:#eae7e2;border-radius:6px;';
      stack.appendChild(ph);
      return;
    }
    imgs.forEach(function (src) {
      var img = document.createElement('img');
      img.src = sizedUrl(src, 800);
      img.alt = p.title || '';
      img.loading = 'lazy';
      stack.appendChild(img);
    });

    /* One image → no carousel arrows */
    var carousel = modal.querySelector('.qv-carousel');
    if (carousel) carousel.classList.toggle('single', imgs.length <= 1);
    stack.scrollLeft = 0;
    updateArrows();
  }

  /* Scroll the gallery carousel by one image width (dir: -1 prev, 1 next) */
  function scrollGallery(dir) {
    var stack = $('qv-gallery-stack');
    if (!stack) return;
    var step = stack.clientWidth || 300;
    stack.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  /* Disable prev/next arrows at the ends of the carousel */
  function updateArrows() {
    var stack = $('qv-gallery-stack');
    if (!stack) return;
    var prevBtn = modal.querySelector('.qv-arrow-prev');
    var nextBtn = modal.querySelector('.qv-arrow-next');
    var maxScroll = stack.scrollWidth - stack.clientWidth;
    if (prevBtn) prevBtn.disabled = stack.scrollLeft <= 2;
    if (nextBtn) nextBtn.disabled = stack.scrollLeft >= maxScroll - 2;
  }

  /* Render one group per option: color-like → swatches, everything else →
     buttons. Shows nothing when the product has no real variant options. */
  function renderOptions() {
    var root = $('qv-options');
    root.innerHTML = '';

    optionNames.forEach(function (name, idx) {
      var values = uniqueOptionValues(idx);
      if (values.length < 1) return;

      var group = document.createElement('div');
      group.className = 'qv-option-group';

      var label = document.createElement('p');
      label.className = 'qv-option-label';
      label.textContent = name;
      group.appendChild(label);

      var list = document.createElement('div');
      var asSwatch = (idx === colorIdx);
      list.className = asSwatch ? 'qv-swatch-list' : 'qv-size-list';

      values.forEach(function (val) {
        /* Available if some variant with this value — holding the OTHER
           currently selected options — is in stock. */
        var available = variants.some(function (v) {
          return v.options[idx] === val && matchesOthers(v, idx) && v.available;
        });
        var isActive = sel[idx] === val;

        var el;
        if (asSwatch) {
          var css = String(val).toLowerCase().replace(/\s+/g, '').replace(/\//g, '-');
          el = document.createElement('span');
          el.className = 'qv-swatch' + (isActive ? ' active' : '') + (!available ? ' sold-out' : '');
          el.title = val + (available ? '' : ' (sold out)');
          /* Prefer a defined --swatch-* var or a real CSS color. Custom names
             like "Garden Green" aren't valid colors → fall back to that
             color's variant image so the swatch isn't blank/white. */
          if (isValidCssColor(css)) {
            el.style.background = 'var(--swatch-' + css + ', ' + css + ')';
          } else {
            var img = swatchImageFor(idx, val);
            if (img) {
              el.style.backgroundImage = 'url(' + sizedUrl(img, 80) + ')';
              el.style.backgroundSize = 'cover';
              el.style.backgroundPosition = 'center';
            } else {
              el.style.background = 'var(--swatch-' + css + ', #ccc)';
            }
          }
        } else {
          el = document.createElement('button');
          el.type = 'button';
          el.className = 'qv-size-btn' + (isActive ? ' active' : '') + (!available ? ' sold-out' : '');
          el.textContent = val;
          el.disabled = !available;
        }
        el.addEventListener('click', function () {
          if (!available) return;
          selectOption(idx, val);
        });
        list.appendChild(el);
      });

      group.appendChild(list);
      root.appendChild(group);
    });
  }

  /* Do all options other than `skipIdx` on variant v match the selection? */
  function matchesOthers(v, skipIdx) {
    for (var j = 0; j < optionNames.length; j++) {
      if (j === skipIdx) continue;
      if (sel[j] !== undefined && v.options[j] !== sel[j]) return false;
    }
    return true;
  }

  /* Pick value `val` at option `idx`, then snap the other options to a valid,
     preferably in-stock combination so the selection is always coherent. */
  function selectOption(idx, val) {
    var candidates = variants.filter(function (v) { return v.options[idx] === val; });
    var pick = candidates.find(function (v) { return v.available && matchesOthers(v, idx); })
            || candidates.find(function (v) { return v.available; })
            || candidates.find(function (v) { return matchesOthers(v, idx); })
            || candidates[0];
    if (pick) sel = pick.options.slice();
    else sel[idx] = val;

    updateSubtitle();
    renderOptions();
    updatePrice();
    if (colorIdx >= 0) syncImageToColor(sel[colorIdx]);
  }

  /* True only if `str` is a color the browser actually understands
     (named color, hex, rgb…). Rejects invalid values that resolve to nothing. */
  var _colorProbe = document.createElement('span');
  function isValidCssColor(str) {
    if (!str) return false;
    _colorProbe.style.color = '';
    _colorProbe.style.color = str;
    return _colorProbe.style.color !== '';
  }

  /* featured_image src of the first variant carrying this option value. */
  function swatchImageFor(idx, val) {
    var v = variants.find(function (vv) {
      return vv.options[idx] === val && vv.featured_image && vv.featured_image.src;
    });
    return v ? v.featured_image.src : '';
  }

  function uniqueOptionValues(idx) {
    var seen = [];
    variants.forEach(function (v) {
      var val = v.options[idx];
      if (val !== undefined && val !== null && seen.indexOf(val) < 0) seen.push(val);
    });
    return seen;
  }

  function updatePrice() {
    var v = currentVariant();
    var priceEl   = $('qv-price');
    var compareEl = $('qv-compare');
    var atc       = $('qv-atc');

    if (!v) {
      priceEl.textContent = '';
      compareEl.style.display = 'none';
      atc.disabled = true;
      atc.textContent = 'UNAVAILABLE';
      return;
    }

    priceEl.textContent = formatMoney(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      compareEl.textContent = formatMoney(v.compare_at_price);
      compareEl.style.display = '';
      priceEl.classList.add('sale');
    } else {
      compareEl.style.display = 'none';
      priceEl.classList.remove('sale');
    }

    atc.disabled = !v.available;
    atc.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
  }

  function syncImageToColor(color) {
    if (colorIdx < 0) return;
    var variant = variants.find(function (v) {
      return v.options[colorIdx] === color && v.featured_image;
    });
    if (variant && variant.featured_image && variant.featured_image.src) {
      var stack = $('qv-gallery-stack');
      var first = stack.querySelector('img');
      if (first) {
        first.style.opacity = '0';
        setTimeout(function () {
          first.src = sizedUrl(variant.featured_image.src, 800);
          first.style.opacity = '1';
        }, 180);
      }
    }
  }

  function currentVariant() {
    /* No real options → the single default variant. */
    if (optionNames.length === 0) return variants[0] || null;
    return variants.find(function (v) {
      for (var j = 0; j < optionNames.length; j++) {
        if (v.options[j] !== sel[j]) return false;
      }
      return true;
    }) || null;
  }

  function addToCart() {
    var v = currentVariant();
    if (!v) return;
    var btn = $('qv-atc');
    btn.disabled = true;
    btn.textContent = 'ADDING…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    })
    .then(function () {
      btn.disabled = false;
      btn.textContent = 'ADD TO CART';
      /* Close quick view, then open cart drawer */
      close();
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      }
    })
    .catch(function (err) {
      console.error('[QV] Cart add failed:', err);
      btn.disabled = false;
      btn.textContent = 'ADD TO CART';
    });
  }

  function toggleDesc() {
    var desc = $('qv-desc');
    var btn  = $('qv-read-more');
    var expanded = desc.classList.toggle('expanded');
    btn.textContent = expanded ? 'Read less' : 'Read more';
  }

  function sizedUrl(src, w) {
    if (!src) return '';
    return String(src).replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_' + w + 'x$1');
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return currencySymbol + parts.join('.');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.openQuickView  = open;
  window.closeQuickView = close;
})();
